import React from "react";

// core components
import Navbar from "../components/Navbar.js";
import ProfilePageHeader from "components/Headers/ProfilePageHeader.js";
import DemoFooter from "../components/Footer.js";
import Attend from "components/Attend.js";
import PastEventHighlights1 from "../components/PastEventHighlights1";
import Photos from "../components/Photos";

function Home() {
  return (
    <div style={{ backgroundColor: "#000", minHeight: "100vh" }}>
      <Navbar />

      <ProfilePageHeader title="PAST EVENT  HIGHLIGHTS" bgColor="#000" />
      <PastEventHighlights1 />
      <section id="attend">
        <Attend />
      </section>
      <Photos />
      <DemoFooter />
    </div>
  );
}

export default Home;
